import { APIS } from "../endpoints";
import api from "../services/api";

export const getDeriveFileData = async (page, limit, searchText) => {
  const formData = new FormData();
  formData.append("page", page);
  formData.append("limit", limit);

  if (searchText) {
    formData.append("search", searchText); // Add search term
  }
  const params = new URLSearchParams(formData);

  const result = await api.get(`${APIS.BASE_URL}${APIS.agraphyfile}`, {
    params: params,
  });

  if (result) {
    return result?.data;
  } else {
    return [];
  }
};

export const uploadFile = async (data) => {
  const formData = new FormData();
  formData.append("agraphyFile", data);

  const result = await api.post(
    `${APIS.BASE_URL}${APIS.agraphyfile}/upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return result || [];
};

export const commitFile = async (id) => {
  const formData = new FormData();
  formData.append("id", id);

  const result = await api.post(
    `${APIS.BASE_URL}${APIS.agraphyfileCommit}`,
    formData,
  );

  return result || [];
};
